import React, { Component, useState } from 'react'
import propTypes from './prop'
import styles from './style'
import { connect } from 'react-redux'
import translator from '../../translate'
import withStyles from '@material-ui/core/styles/withStyles'
import {
  Typography,
  Grid,
  Box,
  CircularProgress,
  Button,
  Alert,
  AlertTitle,
} from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import { componentBoxHideAction } from '../../reducers/component-box/action'
import { customerPortal } from '../../api/limit'
class Subscription extends Component {
  state = {
    loading: false,
  }
  render() {
    const { classes, history, dispatch } = this.props
    const directUrl = () => {
      this.setState({ loading: !this.state.loading })
      customerPortal().then(response => {
        let sessionUrl = response.data.sessionUrl
        window.open(`${sessionUrl}`)
      })
      //routeChange()
      this.setState({ loading: !this.state.loading })
    }

    return (
      <Grid container className={classes.warningGrid}>
        <Grid item paddingBottom={3} className={classes.gridItem}>
          <Typography>{translator._('pricing.subscription')}</Typography>
        </Grid>

        <Grid item className={classes.gridItem}>
          <Button
            size="medium"
            variant="contained"
            color="primary"
            onClick={directUrl}
          >
            {translator._('pricing.paymentDetails')}
          </Button>
        </Grid>
        {this.state.loading == true ? <CircularProgress /> : ''}
      </Grid>
    )
  }
}

Subscription.propTypes = propTypes

const mapStateToProps = response => ({
  componentBox: response.componentBox,
})
export default connect(mapStateToProps)(
  withRouter(withStyles(styles)(Subscription)),
)
